module.exports = __webpack_public_path__ + "static/media/asan-confirmation-icon.266061e7.svg";